import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatLabel = createCustomElementWrapper('kat-label', 'KatLabel', {
    'tooltipPosition': 'tooltip-position',
    'tooltipText': 'tooltip-text',
    'tooltipTriggerIcon': 'tooltip-trigger-icon',
    'uniqueId': 'unique-id',
}, {});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/katal-react/es/label.js
// module id = 1263
// module chunks = 0